export const CUSTOM_DROPDOWN_PREFIX = '__custom__:';

export const encodeCustomDropdownValue = (text) => {
  const trimmed = String(text ?? '').trim();
  return trimmed ? `${CUSTOM_DROPDOWN_PREFIX}${trimmed}` : '';
};

export const decodeCustomDropdownValue = (value) => {
  const str = String(value ?? '');
  return str.startsWith(CUSTOM_DROPDOWN_PREFIX)
    ? str.slice(CUSTOM_DROPDOWN_PREFIX.length)
    : str;
};

export const isCustomDropdownValue = (value) =>
  String(value ?? '').startsWith(CUSTOM_DROPDOWN_PREFIX);

export const isDropdownCustomSelection = (value, regularOptions, getV) => {
  if (value === null || value === undefined || value === '') return false;
  if (isCustomDropdownValue(value)) return true;
  return !regularOptions.some((o) => String(getV(o)) === String(value));
};

export const resolveDropdownDisplayLabel = (value, regularOptions, getV, getL) => {
  if (value === null || value === undefined || value === '') return null;
  if (isCustomDropdownValue(value)) return decodeCustomDropdownValue(value);
  const match = regularOptions.find((o) => String(getV(o)) === String(value));
  return match ? getL(match) : String(value);
};

export const parseDropdownFieldForSave = (raw, toNumFn) => {
  if (isCustomDropdownValue(raw)) {
    return { value: null, custom: decodeCustomDropdownValue(raw) };
  }
  return { value: toNumFn(raw), custom: null };
};

export const CUSTOM_DROPDOWN_FIELD_MAP = [
  { field: 'bhk', customKey: 'bhk_custom' },
  { field: 'property_floor_no', customKey: 'property_floor_no_custom' },
  { field: 'total_floors', customKey: 'total_floors_custom' },
];

export const formValuesFromCustomDropdowns = (raw) => {
  const ef = raw?.extra_fields || {};
  const mapped = {};
  CUSTOM_DROPDOWN_FIELD_MAP.forEach(({ field, customKey }) => {
    mapped[field] = ef[customKey]
      ? encodeCustomDropdownValue(ef[customKey])
      : raw?.[field];
  });
  return mapped;
};

export const saveCustomDropdownsToExtraFields = (fd, extra_fields, toNumFn) => {
  const values = {};
  CUSTOM_DROPDOWN_FIELD_MAP.forEach(({ field, customKey }) => {
    const parsed = parseDropdownFieldForSave(fd?.[field], toNumFn);
    extra_fields[customKey] = parsed.custom || null;
    values[field] = parsed.value;
  });
  return values;
};
